import React from 'react';

import { DocumentInspectorProps } from '../../../types';
import { LinkProps } from '../../Link/Link';
import { LinkInspector } from '../../Link/LinkInspector';
import { ImageMapLinkProps } from './ImageMapLink';

export function ImageMapLinkInspector(
  props: DocumentInspectorProps<ImageMapLinkProps>,
) {
  const assertedProps = props as unknown as DocumentInspectorProps<LinkProps>;
  return <LinkInspector {...assertedProps} />;
}
